<div class="container py-4" *ngIf="line">
  <h2>{{ line.name }} — {{ version }}</h2>
  <p class="text-secondary">CTA: Solicitar demo / cotización.</p>
</div>
